import generic_backend_request_post from 'functions/server/generic_backend_request_post';

async function get_run_status(run_id) {
    /**
     * Fetches the lifecycle status of an optimization run, for polling while a
     * solve is in progress.
     *
     * Solves are asynchronous: POST /problem queues the run and returns a run_id,
     * a worker performs the solve, and the client polls this endpoint until the
     * run reaches a terminal status.
     *
     * @param {string} run_id - The ID of the run to check.
     * @returns {Object} { run_id, status, error, progress, run_datetime_unix }
     *   where status is one of: queued | running | succeeded | failed | cancelled.
     */
    if (!run_id) {
        throw new Error('Run ID is required for get_run_status');
    }

    const retJson = await generic_backend_request_post({ run_id }, '/run_status');
    return retJson;
}

export default get_run_status;
